<div class="gebruikperweek">
  <span class="gebruik-per-week-getal">{{data.gebruikPerWeek}}</span>
  <div *ngIf="data.gebruikPerWeek !== ''" [class]="data.gebruikPerWeekPijltje"></div>
</div>
